import { oz } from '@weft/utils';
import { CurrencySchema } from '../../../primitives/currency-schema';
import { ObjectIdSchema } from '../../../primitives/object-id-schema';
import { PaymentProviderSchema } from '../../../primitives/payment-provider-schema';
import { withNullAsOptional } from '../../../utils/literal-transforms';
import { ExternalPaymentSchema } from '../external-payment-schema';

export const NewPaymentSchema = oz.object({
  accountId: ObjectIdSchema,
  externalId: ObjectIdSchema,
  amount: oz.number(),
  currency: CurrencySchema,
  paymentMethod: PaymentProviderSchema,
  externalPayment: withNullAsOptional(ExternalPaymentSchema),
  status: oz.string(),
  invoiceId: withNullAsOptional(ObjectIdSchema),
  customerId: ObjectIdSchema,
}).openapi('NewPayment');

export type NewPayment = oz.infer<typeof NewPaymentSchema>;